import {isDev} from "@/util/isDev";

export const isProdEnv = () => {
  if (isDev()) {
    return false;
  }

  const urlSplit = location.href.split('.');
  if (urlSplit.some(e => e === 'preview')) {
    return false;
  }

  if (location.hostname === 'localhost') {
    return false
  }

  if (location.hostname === '127.0.0.1') {
    return false
  }

  if (location.hostname.includes('192.168')) {
    return false
  }

  return true
}
